import { useState, useEffect } from 'react'
import { useQuery, useMutation } from 'react-query'
import { AxiosResponse, AxiosError } from 'axios'

const cacheIdentifier = 'get-smart-audit-rules'

import { SmartAuditRules } from './useSmartAuditRules.type'
import { PATH } from '../../constants/global'
import { useAPI } from '../'
import { SmartAuditRequestPayload } from '../../components/views/audits/smartAuditRules/types'
import { APIError } from '../types'
import { getAPIErrorMessage } from '../../utils/functions'

export default function () {
   const [error, setErrors] = useState('')
   const [deleteErrors, setDeleteErrors] = useState('')
   const [pageOptions, setPageOptions] = useState({ skip: 0, take: 10, query: ''})
   const request = useAPI()

   const {
      data,
      isLoading: isLoadingSmartAuditRules,
      refetch: refresh,
      isRefetching,
      isSuccess: isLoadingSuccess,
   } = useQuery<AxiosResponse<SmartAuditRules>>(cacheIdentifier, getSmartAuditsFromAPI)

   const {
      isLoading: isSaveLoading,
      isSuccess: isSaveSuccess,
      mutate,
   } = useMutation(saveSmartAuditRuleWithAPI, {
      onSuccess: () => {
         refresh()
      },
      onError: (error: APIError) => {
         const msg = getAPIErrorMessage(error)
         setErrors(msg)
      }
   })

   const {
      isError: isErrorDeleting,
      isLoading: isDeleting,
      isSuccess: isDeleteSuccess,
      mutate: mutateDelete,
      reset: resetDelete
   } = useMutation(deleteSmartAuditRuleAPI, {
      onSettled: () => {
         refresh();
      },
      onError: (error: APIError) => {
         const msg = getAPIErrorMessage(error);
         setDeleteErrors(msg)
      }
   })

   useEffect(() => {
      refresh({ cancelRefetch: false })
   }, [pageOptions])

   async function getSmartAuditsFromAPI(): Promise<AxiosResponse<SmartAuditRules>> {
      return await request.post(PATH.SMART_AUDIT_RULES.LIST, { ...pageOptions })
   }

   async function deleteSmartAuditRuleAPI(payload: string): Promise<AxiosResponse> {
      return await request.post(`${PATH.SMART_AUDIT_RULES.DELETE}?auditRuleId=${payload}`)
   }

   async function saveSmartAuditRuleWithAPI(
      payload: SmartAuditRequestPayload
   ):
   Promise<AxiosResponse> {
      return await request.post(PATH.SMART_AUDIT_RULES.SAVE, { ...payload })
   }

   const deleteSmartAuditRule = (payload: string) => {
      setDeleteErrors('')
      mutateDelete(payload)
   }

   const saveSmartAuditRule = (payload: SmartAuditRequestPayload) => {
      setErrors('')
      mutate(payload)
   }

   return {
      error,
      isLoadingSmartAuditRules,
      //isUpdating: mutationLoading,
      refresh,
      smartAuditRules: data?.data || {},
      saveSmartAuditRule,
      setPageOptions,
      isLoadingSuccess,
      isRefetchingSmartAuditRules: isRefetching,
      isSaveSuccess,
      isSaveLoading,
      isErrorDeleting,
      isDeleting,
      isDeleteSuccess,
      resetDelete,
      deleteSmartAuditRule,
   }
}